import React from 'react';

const DataDeletion = () => {
    return (
        <div className="max-w-2xl mx-auto px-4 py-10">
            <h1 className="text-3xl font-bold mb-6">User Data Deletion Instructions</h1>

            <p className="mb-4">
                If you have submitted personal information to our website (<a href="https://www.dysband.com" className="text-blue-600 underline">https://www.dysband.com</a>) and would like your data deleted from our records, please follow the instructions below.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">How to Request Data Deletion</h2>
            <p className="mb-4">
                Send an email to:
            </p>

            <p className="mb-4 font-medium">
                📧 <a href="mailto:info@dysband.com" className="text-blue-600 underline">contact@dysband.com</a>
            </p>

            <p className="mb-4">
                Please use the subject line: <span className="font-semibold">"Data Deletion Request"</span>
            </p>

            <p className="mb-4">
                In your message, include any relevant details (such as your name or email used with our services) to help us locate your data.
            </p>

            <p className="mb-4">
                We will review and process your request within <span className="font-semibold">7 business days</span>.
            </p>

            <p className="mt-10 text-sm text-gray-500">
                If you accessed our services through Facebook, you can also remove your data directly by visiting your Facebook app settings.
            </p>
        </div>
    );
};

export default DataDeletion;
